import Base, {
  axios,
  setPromise,
  getEndpoint,
  omitId
} from './base'

export {
  APIURI,
  client_secret,
  client_id,
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  getErrorMessagesWithKeys,
  endpoints,
  services,
  handlePromise,
  promise,
  setPromise,
  getEndpoint
} from './base'

const myServices = {}

export const getMyOrder = myServices.getMyOrder = async (options = {}) => {
  const endPoint = getEndpoint('user.orders.get', {}, '/customer/order/{id}', options)
  options = options || {}
  if (!options.include) {
    options.include = 'transactions'
  }
  const {data = {}} = await axios.get(endPoint, {params: omitId(options)})
  return data
}
setPromise('user.order.get', getMyOrder)

export const getMyOrders = myServices.getMyOrders = async (payload, options = {}) => {
  const endPoint = getEndpoint('user.orders.get', {}, '/customer/order', options)
  payload = payload || {}
  payload.page_size = payload.page_size || 9999
  if (!payload.include) {
    payload.include = 'transactions'
  }
  const {data = {}} = await axios.get(endPoint, {params: omitId(payload)})
  return data
}
setPromise('user.orders.get', getMyOrders)

export const getMySubscriptions = myServices.getMySubscriptions = async (options = {}) => {
  const endPoint = getEndpoint('user.subscriptions.get', {}, '/customer/subscription', options)
  const {data} = await axios.get(endPoint)
  return data
}
setPromise('user.subscriptions.get', getMySubscriptions)

export const cancelMySubscription = myServices.cancelMySubscription = async (id, options = {}) => {
  const endPoint = getEndpoint('user.subscription.cancel', {id}, '/customer/subscription/{id}/cancel', options)
  const {data} = await axios.post(endPoint)
  return data
}
setPromise('user.subscription.cancel', cancelMySubscription)

export const updateMySubscriptionPaymentMethod = myServices.updateMySubscriptionPaymentMethod = async (id, payload, options = {}) => {
  const endPoint = getEndpoint('user.subscription.paymentMethod.update', {id}, '/customer/subscription/{id}/updatePaymentMethod', options)
  const {data} = await axios.post(endPoint, payload)
  return data
}
setPromise('user.subscription.paymentMethod.update', updateMySubscriptionPaymentMethod)

export const getMyPaymentMethods = myServices.getMyPaymentMethods = async (payload, options = {}) => {
  let endPoint = getEndpoint('user.billing.paymentMethods.get', payload, '/customer/biller/card/{id}', options)
  endPoint = _.trimEnd(endPoint, '/')
  const {data = {}} = await axios.get(endPoint, omitId(payload))
  return data.data || {}
}
setPromise('user.billing.paymentMethods.get', getMyPaymentMethods)

export const createMyPaymentMethod = myServices.createMyPaymentMethod = async (payload, options = {}) => {
  const endPoint = getEndpoint('user.billing.paymentMethods.create', payload, '/customer/biller/card', options)
  const {data} = await axios.post(endPoint, omitId(payload))
  return data
}
setPromise('user.billing.paymentMethods.create', createMyPaymentMethod)

export const updateMyPaymentMethod = myServices.updateMyPaymentMethod = async (payload, options = {}) => {
  const endPoint = getEndpoint('user.billing.paymentMethods.update', payload, '/customer/biller/card/{id}', options)
  const {data} = await axios.put(endPoint,  omitId(payload))
  return data
}
setPromise('user.billing.paymentMethods.update', updateMyPaymentMethod)

export const updateOrCreateMyPaymentMethod = myServices.updateOrCreateMyPaymentMethod = async (payload, options = {}) => {
  if (payload.id) {
    return await updateMyPaymentMethod(payload, options)
  } else {
    return await createMyPaymentMethod(payload, options)
  }
}
setPromise('user.billing.paymentMethods.updateOrCreate', updateOrCreateMyPaymentMethod)

export const deletePaymentMethod = myServices.deletePaymentMethod = async (payload, options = {}) => {
  const endPoint = getEndpoint('user.billing.paymentMethods.delete', payload, '/customer/biller/card/{id}', options)
  const {data} = await axios.delete(endPoint)
  return data
}
setPromise('user.billing.paymentMethods.delete', deletePaymentMethod)

export const setDefaultPaymentMethod = myServices.setDefaultPaymentMethod = async (payload, options = {}) => {
  const endPoint = getEndpoint('user.billing.paymentMethods.default', payload, '/customer/biller/card/{id}/primary', options)
  const {data} = await axios.post(endPoint)
  return data
}
setPromise('user.billing.paymentMethods.default', setDefaultPaymentMethod)

export const socialLogin = myServices.socialLogin = async (payload, options = {}) => {
  const endPoint = getEndpoint('user.social.login', payload, '/social/auth/{provider}', options)
  const {data = {}} = await axios.post(endPoint, omitId(payload, 'provider'))
  return data.data
}
setPromise('user.social.login', socialLogin)

export const socialRegister = myServices.socialLogin = async (payload, options = {}) => {
  const endPoint = getEndpoint('user.social.register', payload, '/social/register/{provider}', options)
  const {data = {}} = await axios.post(endPoint, omitId(payload, 'provider'))
  return data.data
}
setPromise('user.social.register', socialRegister)

export default {
  ...Base,
  ...myServices
}
